import { render } from "./dataset.vue?vue&type=template&id=59cfddad"
import script from "./dataset.vue?vue&type=script&lang=js"
export * from "./dataset.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__